import React from "react"
import { Link } from "gatsby"
const item = ({ image, name, description, link }, key) => {
  return (
    <>
      {link ? (
        <Link className="item" key={key} to={link}>
          <div className="item__image">
            <img src={image} alt="" />
          </div>
          <div className="bold">{name}</div>
          {description && <p>{description}</p>}
        </Link>
      ) : (
        <div className="item" key={key}>
          <div className="item__image">
            <img src={image} alt="" />
          </div>
          <div className="bold">{name}</div>
          {description && <p>{description}</p>}
        </div>
      )}
    </>
  )
}

export default item
